import { useMutation } from "@tanstack/react-query";

import { axios } from "@/client/libs/axios";

import { pollAIResult } from "../ai/poll";

export type AtsSuggestion = {
  category?:
    | "profile"
    | "skills"
    | "experience"
    | "education"
    | "languages"
    | "projects"
    | "keywords"
    | "formatting"
    | "general";
  suggestion?: string;
};

export type AtsScoreResult = {
  ats_score?: number;
  skills_match_percentage?: number;
  experience_relevance?: number;
  matching_keywords?: string[];
  missing_keywords?: string[];
  improvement_suggestions?: AtsSuggestion[];
  summary?: string;
};

export type AtsQuote = {
  feature: "score";
  tokensIn: number;
  tokensOut: number;
  points: number;
  costFcfa: number;
  balance: number;
  affordable: boolean;
};

type ScorePayload = {
  resume: Record<string, unknown>;
  jobdesc: string;
};

type QuotePayload = {
  resume: Record<string, unknown>;
  jobDescription: string;
};

export const quoteAtsAnalysis = async ({ resume, jobDescription }: QuotePayload) => {
  const response = await axios.post<AtsQuote>("ai/quote", {
    feature: "score",
    resume: JSON.stringify(resume),
    jobDescription: jobDescription.trim(),
  });

  return response.data;
};

export const scoringAndAdvices = async (
  resumeId: string,
  resume: Record<string, unknown>,
  jobdesc: string,
) => {
  const response = await axios.post<{
    key: string;
  }>("ai/ats-advice", {
    id: resumeId,
    data: JSON.stringify(resume),
    jobdesc: jobdesc.trim(),
  });

  return pollAIResult<AtsScoreResult>(response.data.key);
};

export const useAtsQuote = () => {
  return useMutation({
    mutationFn: quoteAtsAnalysis,
  });
};

export const useScore = (resumeId: string) => {
  return useMutation({
    mutationFn: ({ resume, jobdesc }: ScorePayload) => scoringAndAdvices(resumeId, resume, jobdesc),
  });
};
